import React, { useState, useCallback } from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { useLanguage } from '../../contexts/LanguageContext';
import { Container } from '../../components/layout/Container';
import { ContactInfoCard } from './ContactInfoCard';
import { ContactForm } from './ContactForm';
import { sendContactForm } from '../../services/api';

const initialFormState = {
  name: '',
  email: '',
  message: '',
};

/**
 * Contact page component
 */
const Contact = () => {
  const [form, setForm] = useState(initialFormState);
  const { t } = useLanguage();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      // Send contact form to backend API
      await sendContactForm(form);
      setSubmitStatus('success');
      setForm(initialFormState);
    } catch {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  }, [form]);

  return (
    <main className="contact-page">
      <PageHeader
        title={t('pages.contact.title')}
        subtitle={t('pages.contact.subtitle')}
      />

      <section className="py-12 sm:py-16 md:py-24" aria-label={t('pages.contact.sectionAria')}>
        <Container>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 items-start">
            <ContactInfoCard />
            <ContactForm
              form={form}
              onChange={handleChange}
              onSubmit={handleSubmit}
              isSubmitting={isSubmitting}
              submitStatus={submitStatus}
            />
          </div>
        </Container>
      </section>
    </main>
  );
};

export default Contact;
